//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    color: {
      type: String,
      required: false,
      default: ''
    },
    position: {
      type: String,
      required: false,
      default: ''
    },
    noMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    long: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    className: {
      type: String,
      required: false,
      default: ''
    }
  },
  data(){
    return {
      hidden: false,
      otherColor: null
    }
  },
  mounted(){
    if(this.position && this.position === 'fixed') {
      const options = {
          // root: null,
          rootMargin: `50px`,
          // threshold: 0.01
      }

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.hidden = true
          } else {
            this.hidden = false
          }
        })
      }, options)

      this.observer.observe(document.querySelector('footer'))

      // Это для смены цвета кнопки, но не уверен что нужно будет это вообще
      if (!this.color) {
        const marginTop = (window.innerHeight - 100) * -1

        const optionsOther = {
          // root: null,
          rootMargin: `${marginTop}px 0px -50px 0px`,
          // threshold: 0.01
        }

        this.observerOther= new IntersectionObserver((entries, observer) => {
          for(let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              this.otherColor = 'light'
              return
            }
          }
          this.otherColor = ''
        }, optionsOther)


        document.querySelectorAll('.dark-trigger').forEach(elem => {
          this.observerOther.observe(elem)
        })
      }
    }
  },
  beforeDestroy() {
    if(this.position && this.position === 'fixed') {
      if (this.observer) {
        this.observer.unobserve(document.querySelector('footer'))
      }

      if (!this.color) {
        document.querySelectorAll('.dark-trigger').forEach(elem => {
          if (this.observer) {
            this.observerOther.unobserve(elem)
          }
        })
      }
    }
  }
}
